var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 4C15.0841 4 14.6319 4.1873 14.2985 4.5207C13.9651 4.8541 13.7778 5.30628 13.7778 5.77778V11.1111C13.7778 11.5826 13.9651 12.0348 14.2985 12.3682C14.6319 12.7016 15.0841 12.8889 15.5555 12.8889C15.7913 12.8889 16.0174 12.9825 16.1841 13.1492C16.3508 13.3159 16.4444 13.542 16.4444 13.7778V14.6667C16.4444 15.1382 16.2571 15.5903 15.9237 15.9237C15.5903 16.2571 15.1382 16.4444 14.6667 16.4444C14.4309 16.4444 14.2048 16.5381 14.0381 16.7048C13.8714 16.8715 13.7778 17.0976 13.7778 17.3333V19.1111C13.7778 19.3469 13.8714 19.573 14.0381 19.7397C14.2048 19.9064 14.4309 20 14.6667 20C16.0811 20 17.4377 19.4381 18.4379 18.4379C19.4381 17.4377 20 16.0812 20 14.6667V5.77778C20 5.30628 19.8127 4.8541 19.4793 4.5207C19.1459 4.1873 18.6937 4 18.2222 4H15.5555Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 4C5.30628 4 4.8541 4.1873 4.5207 4.5207C4.1873 4.8541 4 5.30628 4 5.77778V11.1111C4 11.5826 4.1873 12.0348 4.5207 12.3682C4.8541 12.7016 5.30628 12.8889 5.77778 12.8889C6.01353 12.8889 6.23962 12.9825 6.40632 13.1492C6.57302 13.3159 6.66667 13.542 6.66667 13.7778V14.6667C6.66667 15.1382 6.47937 15.5903 6.14597 15.9237C5.81257 16.2571 5.36038 16.4444 4.88889 16.4444C4.65314 16.4444 4.42705 16.5381 4.26035 16.7048C4.09365 16.8715 4 17.0976 4 17.3333V19.1111C4 19.3469 4.09365 19.573 4.26035 19.7397C4.42705 19.9064 4.65314 20 4.88889 20C6.30338 20 7.65993 19.4381 8.66012 18.4379C9.66032 17.4377 10.2222 16.0812 10.2222 14.6667V5.77778C10.2222 5.30628 10.0349 4.8541 9.70152 4.5207C9.36812 4.1873 8.91594 4 8.44444 4H5.77778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatQuote);
export default __webpack_public_path__ + "static/media/format_quote.265ef7f64c9e21bef4d79ae2098b4c15.svg";
export { ForwardRef as ReactComponent };